import CategoryItem from './CategoryItem/CategoryItem'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { StaticPageWrapper } from 'components/common/StaticPageWrapper/StaticPageWrapper'
import { Typography } from '@material-ui/core'
import { faPlay } from '@fortawesome/free-solid-svg-icons'
import supportList from './support.json'
import { useStyles } from './styles'

export const Support: React.FC = () => {
    const classes = useStyles()

    const refs = supportList.reduce((acc, list) => {
        acc[list.category] = React.createRef()
        return acc
    }, {})

    const scrollToCategory = category =>
        refs[category].current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })

    return (
        <StaticPageWrapper title="Support">
            <Typography variant="subtitle1" gutterBottom>
                What can we help you with?
            </Typography>
            {supportList.map((item, index) => (
                <div key={index} onClick={() => scrollToCategory(item.category)}>
                    <Typography variant="subtitle2" className={classes.option}>
                        {item.category}
                        <FontAwesomeIcon className={classes.playIcon} icon={faPlay} />
                    </Typography>
                </div>
            ))}
            <Typography className={classes.contact} variant="subtitle2">
                Can't find what you're looking for?{' '}
                <a href="mailto:support@benovel.com" target="_blank" rel="noopener noreferrer">
                    Contact support
                </a>
            </Typography>
            {supportList.map((item, index) => (
                <CategoryItem
                    key={index}
                    ref={refs[item.category]}
                    category={item.category}
                    questionsList={item.questions}
                />
            ))}
        </StaticPageWrapper>
    )
}

export default Support
